import React, { useContext } from 'react';
import { View } from '@/styles/reactnative';
import AccountDeposit from './AccountDeposit';
// import AccountConvert from './AccountConvert'
import AccountTransfer from './AccountTransfer';
import { ThemeContext } from '@/theme/ThemeProvider';
import { useMyProfile } from '@app/hooks/user/myprofile';
import { useDemoTradingStore } from '@app/hooks/trade/demoTradingStore';

const DerivativesAccountBtns = () => {
  const { SubmenuBg, gray, textw } = useContext(ThemeContext).theme.COLORS;
  const { data: myinfo } = useMyProfile();
  const { isDemoMode } = useDemoTradingStore();

  // KYC 인증 상태 확인 (level 1 이상이면 인증됨)
  const isKYCVerified = myinfo?.level && myinfo.level > 1 && myinfo.level !== 7;

  return (
    <View
      style={{
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: 8,
        marginTop: 12,
        cursor: 'pointer',
      }}
    >
      {/* 데모 모드에서는 입금 버튼 숨김 */}
      {!isDemoMode && isKYCVerified && (
        <AccountDeposit bgColor={gray} color={textw} />
      )}
      {/* <AccountConvert bgColor={gray} color={textw} /> */}
      <AccountTransfer bgColor={SubmenuBg} color={textw} />
    </View>
  );
};

export default DerivativesAccountBtns;
